module.exports = __webpack_public_path__ + "img/Logo-small-green.a942a777.png";